// Constantes globais da aplicação
export const APP_CONSTANTS = {
    WHATSAPP_NUMBER: "558199130020",
    WHATSAPP_FORMATTED: "+55 81 9913-0020",
    COMPANY_NAME: "LogPlace",
    COMPANY_WEBSITE: "https://logplace.com.br"
} as const
